import { render, staticRenderFns } from "./TopCustomersOverallChart.vue?vue&type=template&id=4dd8ed76"
import script from "./TopCustomersOverallChart.vue?vue&type=script&lang=js"
export * from "./TopCustomersOverallChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports